import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import routing from './routes';
import {Router, Switch, Route} from 'react-router-dom';
import history from './history';
import {restoreSession} from './auth';
import {setCountries} from './redux/actions';
import {getCountries} from './api/flightApi';
import {mergeCountriesWithFallback} from './data/countryHelpers';
import {ScrollToTop} from './components/shared';
import WhatsAppButton from './components/shared/WhatsAppButton';
import ErrorBoundary from './components/ErrorBoundary';
import {initAnalytics, trackPageview} from './utils/analytics';
import {initAdSense, shouldShowAds} from './utils/adsense';
import './styles/index.scss';

function App(props) {
	useEffect(
		() => {
			restoreSession();
			initAnalytics();
			initAdSense(history.location.pathname);
			trackPageview(history.location.pathname);
			const unlisten = history.listen((location) => {
				trackPageview(location.pathname);
				if (shouldShowAds(location.pathname)) initAdSense(location.pathname);
			});

			if (props.countries.length == 0) {
				getCountries()
					.then((response) => {
						props.setCountries(mergeCountriesWithFallback(response.data));
					})
					.catch((error) => {
						console.log("Countries list", error);
						props.setCountries(mergeCountriesWithFallback([]));
					});
			}

			// if (props.error !== '') {
			// 	swal({
			// 		title: props.error
			// 	});
			// }

			return () => unlisten();
		},
		[]
		// [props.countries, props.currentUser.email]
	);

	return (
		<ErrorBoundary>
			<Router history={history}>
				<ScrollToTop />
				<WhatsAppButton />
				{routing}
			</Router>
		</ErrorBoundary>
	);
}

const mapStateToProps = ({userStore, extras}) => {
	return {
		currentUser: userStore.currentUser,
		countries: extras.countries,
		error: extras.error
	};
};

const mapDispatchToProps = {
	setCountries
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
